import { IListApiRequest, IListApiResponse } from 'api/types'
import { HeaderType, LANGUAGE } from './utils'

export enum PLACEMENT_TYPE {
  BANNER = 'BANNER_ADS',
  INTERSTIAL = 'INTERSTITIAL_ADS',
  REWARDED = 'REWARDED_ADS',
  VIDEO = 'VIDEO_ADS'
}

export enum ADVERTISEMENT_TYPE {
  HOMESCREEN = 'HOME_SCREEN',
  REPORTSCREEN = 'REPORT_PAGE'
}

export enum LANGUAGES {
  ENGLISH = 'ENGLISH',
  HINDI = 'HINDI',
  MARATHI = 'MARATHI'
}
export enum TemplateStatus {
  Initiate = 'Initiate',
  ApprovedDTL = 'ApprovedDTL',
  ApprovedAdmin = 'ApprovedAdmin',
  DisApprovedDTL = 'DisApprovedDTL',
  DisApprovedAdmin = 'DisApprovedAdmin',
  PendingAdmin = 'PendingAdmin',
  PendingDTL = 'PendingDTL'
}
export interface AdvertisementListParams {
  size?: number;
  page?: number;
  [key: string]: string | number | undefined;
}
export interface UserTemplates {
  id?: number;
  status: string;
  reason?: string;
}
export interface Advertisement {
  id?: string;
  active: boolean;
  message: string;
  redirect_url: string;
  subId?: string;
  video?: string;
  placementType: PLACEMENT_TYPE;
  type: ADVERTISEMENT_TYPE;
  languages: LANGUAGES;
  image?: string;
  duration: number;
  name: string;
  channelOnboarding: {
    id: string | number
  };
  company?: string;
  templateType?: string;
}

export interface WhatsAppTemplate {
  channelId: string;
  id: string;
  name: string;
  language: LANGUAGE;
  status: string;
  channel: string;
  createdAt: string;
  updatedAt: string;
}

export interface WhatsAppTemplateFields {
  channelId: string;
  templateName: string;
  language: LANGUAGE;
  includeHeader: boolean;
  headerType: HeaderType | undefined;
  headerText?: string;
  bodyText: string;
  mediaFile?: File | null;
}
export interface SmsTemplate {
  id?: string;
  message: string;
  name: string;
  channel?: string;
  channelOnboarding: {
    id: string
  };
}

export type WhatsAppTemplateSaveRequest = {
  whatsAppTemplateDto: WhatsAppTemplateFields,
  file: File | Blob | null
}

export type AdvertisementSaveRequest = {
  advertisementDTO: Advertisement,
  image: File | null,
  video: File | null
}

export interface DeleteTemplateRequest {
  channelId: string;
  templateId: string;
  templateName: string;
}
export type SmsTemplateSaveRequest = SmsTemplate
export type TemplateListResponse = IListApiResponse<WhatsAppTemplate>
export type TemplateListRequest = IListApiRequest<WhatsAppTemplate>
export type SmsListRequest = IListApiRequest<SmsTemplate>
export type SmsListResponse = IListApiResponse<SmsTemplate>
export type AdvertisementListRequest = IListApiRequest<Advertisement>
export type AdvertisementListResponse = IListApiResponse<Advertisement>
